import React, { useState } from 'react'
import useUtenti from '../../hooks/useUtenti'
import { Button, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const InvitaAmicoPage = () => {

  const {inviteFriend, loadingStateUtenti} = useUtenti();
  const user = useSelector((state) => state.user.userData);
  
  const [friendData, setFriendData] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFriendData({
      ...friendData,
      [name]: value
    });
  };

  const handleInvitaAmico = async () => {
    const obj = {
        ...friendData,
        username: user?.sub
    }
    const res = await inviteFriend(obj);
    if(res) {
      setFriendData({})
    }
  }

  return (
    <div className={`card custom-card w-100 shadow`}>
    <div className='p-5'>
      <div className='container'>
        <div className='d-flex justify-content-between'>
          <div className='d-flex gap-3'>
            <div className={`custom-icon-container`}>
              <i className={`bi custom-icon bi-people fs-2`}></i>
            </div>
            <div className='align-self-center'>
              <span className='fs-4 d-block'><i><b>Invita amico</b></i></span>
            </div>
          </div>
        </div>
        <div className='py-5'>
        <div className='row'>
            <div className='col-sm-12 col-md-4 my-2'>
                <span><b>Nome dell'amico</b></span>
                <input type='text' name="nome_amico" value={friendData.nome_amico || ""}   onChange={handleInputChange} className='form-control' placeholder="Inserisci il nome" />
            </div>
            <div className='col-sm-12 col-md-4 my-2'>
            <span><b>Email dell'amico</b></span>
                <input type='email' name="email_amico" value={friendData.email_amico || ""} onChange={handleInputChange} className='form-control' placeholder="Inserisci l'email" />
            </div>
            <div className='col-sm-12 col-md-4 my-2'>
                {
                    !loadingStateUtenti.isLoadingInviteFriend ?  
                    <button className='btn btn-primary w-100 mt-4' onClick={handleInvitaAmico}>Invia invito</button>
                    :
                    <Button variant="primary" disabled className='w-100 mt-4'>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                    Invito in corso...
                    </Button>
                }
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default InvitaAmicoPage